//#region redux
import { missingDocumentSnoozed } from "store/actions/missingDocumentActions";
import { useDispatch } from "react-redux";
//#endregion
//#region types
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
//#endregion
import useSnoozeAction from "components/common/useSnoozeAction";

function useMissingDocumentSnoozeAction(id: number, markAsDone: (id: number) => void) {
  const dispatch = useDispatch();

  const onSnoozeSuccess = () => {
    dispatch(missingDocumentSnoozed(id));
    markAsDone(id);
  };

  const { snoozeAction } = useSnoozeAction(id, WintSuperkollAPIModel.TodoType.MissingDocument, onSnoozeSuccess);

  return snoozeAction;
}

export default useMissingDocumentSnoozeAction;
